import { render, staticRenderFns } from "./productComparison.vue?vue&type=template&id=7ecf0a26&scoped=true"
import script from "./productComparison.vue?vue&type=script&lang=js"
export * from "./productComparison.vue?vue&type=script&lang=js"
import style0 from "./productComparison.vue?vue&type=style&index=0&id=7ecf0a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecf0a26",
  null
  
)

export default component.exports